import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../../../../../config/queryKeys'
import {
  getPlayerWithPermission,
  type PlayerProfileResponse,
  type PlayerWithPermission,
} from '../../../../../services/player/playerProfile'

/**
 * GET /players/:id with its permission metadata — the ONE query behind the
 * Player page, its admin gate and the Player Details form. Callers narrow it
 * with `select`, so they share a single request and cache entry.
 */
export const usePlayerWithPermission = <
  TPlayer = PlayerProfileResponse,
  TSelected = PlayerWithPermission<TPlayer>
>(
  playerId: string | undefined,
  select?: (response: PlayerWithPermission<TPlayer>) => TSelected
) =>
  useQuery({
    queryKey: queryKeys.player.withPermission(playerId),
    queryFn: () => getPlayerWithPermission<TPlayer>(playerId as string),
    enabled: Boolean(playerId),
    select,
  })
